/**
 * @fileoverview AR-924 — "Upload" action under the Deliverable sub-header: a real button (keyboard
 * reachable) styled as the Figma light-purple pill.
 */

import { Badge, Tooltip } from '@mantine/core'
import { IconUpload } from '@tabler/icons-react'
import { useTranslation } from 'react-i18next'

/** Figma: 26px pill, 13px semibold label, 14px bold arrow. */
const ICON_SIZE = 14
const ICON_STROKE = 2.5

const DISABLED_OPACITY = 0.5

interface DeliverableUploadBadgeProps {
  readonly onClick: () => void
  /** Everyone already submitted this deliverable themselves: nobody left to upload for. */
  readonly disabled?: boolean
}

export function DeliverableUploadBadge({ onClick, disabled = false }: DeliverableUploadBadgeProps) {
  const { t } = useTranslation()
  const badge = (
    <Badge
      component="button"
      type="button"
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
      aria-disabled={disabled}
      variant="light"
      size="lg"
      radius="sm"
      leftSection={<IconUpload size={ICON_SIZE} stroke={ICON_STROKE} style={{ display: 'block' }} />}
      sx={{
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? DISABLED_OPACITY : 1,
        textTransform: 'none',
        fontWeight: 600,
        alignSelf: 'center',
      }}
      aria-label={t('task_tracker.upload_for_class.title')}
    >
      {t('task_tracker.table.upload')}
    </Badge>
  )
  if (!disabled) return badge
  return (
    <Tooltip label={t('task_tracker.table.upload_everyone_submitted')} withArrow withinPortal>
      {badge}
    </Tooltip>
  )
}
